import useSettingForm from '../form/useSettingForm';
import { useStudentContext } from '../../../context/MyStudentContextProvider';
import { useDomain } from '../../../../../states/AppDomainProvider';
import RedXPrompting from '../../../../settings/interaction/RedXPrompting';

const RedXPromptingSettings = () => {
  const { updateProfileSettingsOnChange } = useSettingForm('Red X Prompting');
  const { studentsDomain } = useDomain();
  const { currentSelectedStudentId } = studentsDomain.domainData;
  const { myStudentDomain } = useStudentContext();
  const { selectedStudentProfile } = myStudentDomain.domainData;

  const onChange = (newValue) => {
    updateProfileSettingsOnChange(currentSelectedStudentId, {
      prompt: newValue,
    });
  };

  return (
    <RedXPrompting
      profile={selectedStudentProfile}
      onChangeCallback={(newValue) => onChange(newValue)}
    />
  );
};

export default RedXPromptingSettings;
